import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Metal Gates & Railings',
    image: '/images/fencing-gates/fencing-gates-railings.png',
  },
  {
    title: 'Fence Panels & Posts',
    image: '/images/fencing-gates/fencing-panels-posts.png',
  },
  {
    title: 'Steel Tubing & Sections',
    image: '/images/fencing-gates/fencing-steel-tubing.png',
  },
  {
    title: 'Decorative Ironwork',
    image: '/images/fencing-gates/fencing-ironwork.png',
  },
  {
    title: 'Metal Offcuts & Hardware',
    image: '/images/fencing-gates/fencing-metal-offcuts.png',
  },
  {
    title: 'Mesh & Wire Fencing',
    image: '/images/fencing-gates/fencing-mesh-wire.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your postcode and what fencing or gate metal needs clearing.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around your install or removal day.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Gates, panels and ironwork leave the job through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your team stays on installs while old fencing metal is cleared away.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep replacements and strip-outs tidy with accountable metal clearances.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing time hauling gates and panels yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Fencing metals are recovered for reuse instead of mixed waste streams.',
  },
  {
    title: 'Built for install crews',
    body: 'Share access notes and photos so collectors arrive ready for fencing scrap.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear job leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Metal recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function FencingGatesPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="fg-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="fg-hero-heading">
              Scrap collection for <span>fencing & gate installers</span>
            </h1>
            <p className="kf-lead">
              Clear gates, panels, railings and ironwork quickly and responsibly — so your next
              install or replacement stays tidy and on schedule.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-fencing-gates.png"
              alt="Fencing and gate scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for fencing crews — gates, panels, tubing, ironwork and offcuts
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="fg-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="fg-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from fencing installs, gate replacements and strip-outs</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="fg-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="fg-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clear site</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="fg-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="fg-why-heading">Why fencing & gate installers choose SnapScrap</h2>
            <p>Clear space, keep installs moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your fencing & gate scrap for free today</h2>
            <p>
              List leftovers from your next fencing or gate job and get matched with a licensed
              collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
